(function() {

	if (!document.querySelector('.subnavigation-holder')) {
		return;
	}

	var subnavigationHolder = document.querySelector('.subnavigation-holder');
	var subnavigationList = subnavigationHolder.querySelectorAll('li');


	var scrollOptions = {
		speed: 200,
	};

	var i;
	for (i = 0; i < subnavigationList.length; i++) {
		subnavigationList[i].addEventListener('click', function(event) {
			event.preventDefault();
			var targetId = this.querySelector('a').getAttribute('href');
			scrollToId(targetId);
		}, false);
	}

	function scrollToId(targetId) {
		var target = document.getElementById(targetId.substr(1));
		if(!target) {
			return;
		}
		var navigationHeight = (window.innerWidth < 1180) ? 105 : 0;
		var targetOffset = target.getBoundingClientRect().top + window.pageYOffset - navigationHeight - 10;
		animateScrollTo(targetOffset, scrollOptions);
	}

	// if there is a hash on page load, scroll there as well
	if(window.location.hash) {
		scrollToId(window.location.hash);
	}

}());
